import {
  getCalculationExtraInfo,
} from 'components/common/summaryCalculator/calculation-extra-info'
import {
  summaryProductTnvedReceipt,
} from './tnved-review-utils'
import CalculationProductTnvedCell from './components/calculation-product-tnved-cell'

export const getApplicationCalculationExtraInfo = ({
  calculation,
  calculationSnapshotProductCodes,
  tnvedReviews,
  tnvedChangesConfirmed,
  translate,
}: AppCalcInfoParams): SummaryCalculatorExtraInfo => getCalculationExtraInfo({
  calculation,
  translate,
  resolveProductCodeValue: ({ invoiceId, product, invoiceProductsById }) => {
    const receipt = summaryProductTnvedReceipt({
      invoiceId,
      product,
      reviews: tnvedReviews,
      tnvedChangesConfirmed,
      invoiceProductsById,
      calculationSnapshotProductCodes,
    })
    return <CalculationProductTnvedCell {...receipt} />
  },
})
